export default "__VITE_ASSET__DaQqb0jx__"